import { axiosInstance } from '../App'
import { ExternalHealthEntityPlanDTO } from '../dto/ExternalHealthEntityPlanDTO'

export function getExternalHealthEntityPlans(healthEntityPlanId: number): Promise<ExternalHealthEntityPlanDTO[]> {
  return axiosInstance.get(`/api/secured/healthentity/plans/${healthEntityPlanId}/external-plans`)
    .then((response) => response.data as ExternalHealthEntityPlanDTO[])
}

export function createExternalHealthEntityPlan(
  healthEntityPlanId: number,
  payload: ExternalHealthEntityPlanDTO,
): Promise<ExternalHealthEntityPlanDTO> {
  return axiosInstance.post(`/api/secured/healthentity/plans/${healthEntityPlanId}/external-plans`, payload)
    .then((response) => response.data as ExternalHealthEntityPlanDTO)
}

export function updateExternalHealthEntityPlan(
  healthEntityPlanId: number,
  externalId: string,
  payload: ExternalHealthEntityPlanDTO,
): Promise<ExternalHealthEntityPlanDTO> {
  return axiosInstance.put(`/api/secured/healthentity/plans/${healthEntityPlanId}/external-plans/${externalId}`, payload)
    .then((response) => response.data as ExternalHealthEntityPlanDTO)
}

export function deleteExternalHealthEntityPlan(healthEntityPlanId: number, externalId: string): Promise<void> {
  return axiosInstance.delete(`/api/secured/healthentity/plans/${healthEntityPlanId}/external-plans/${externalId}`)
    .then(() => undefined)
}

export function getCanManageExternalHealthEntityPlans(): Promise<boolean> {
  return axiosInstance.get('/api/secured/healthentity/plans/permissions')
    .then((response) => response.data as boolean)
}
